import React from "react";
export const Context = React.createContext({});
export const StoreContext = React.createContext({});
export const OnlineContext = React.createContext({});

export function useOnlineContext() {
    return React.useContext(OnlineContext);
}